import { render, staticRenderFns } from "./PointTopUp.vue?vue&type=template&id=782f9044"
import script from "./PointTopUp.vue?vue&type=script&lang=js"
export * from "./PointTopUp.vue?vue&type=script&lang=js"
import style0 from "./PointTopUp.vue?vue&type=style&index=0&id=782f9044&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports